export default "__VITE_ASSET__BH1on5ck__"